import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux/es/exports";

import {
  appstore,
  googleplay,
  heroimg,
  banner1,
  banner2,
} from "../../assets/img";
import { useNavigate } from "react-router-dom";
import { fetchPostalCodes } from "../../redux/Actions";
import { checkShopListFlow, setValue } from "../../utility";
import {
  fetchAddressByPincode,
  fetchGetShopByPinCode,
  fetchSaveAddress,
} from "../../redux/Actions/checkoutPageActions";
import { DebounceInput } from "react-debounce-input";
import * as yup from "yup";
import { UKPostalCode } from "../core/regex";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Select from "react-select";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import SectionOfferSingle from "../offerSingle";
import axios from "axios";
import {
  clearCart,
  clearCartCount,
  setOrderType,
} from "../../redux/Actions/cartCountAction";
import { clearUserProductCategories } from "../../redux/Actions/productCategoriesAction";

const searchPinCodeFormSchema = yup.object().shape({
  pinCode: yup
    .string()
    .required("Pin code is required")
    .matches(UKPostalCode, "Enter a valid Pin code")
    .trim()
    .max(8, "Enter a valid Pin code"),
});

const addressFormSchema = yup.object().shape({
  address: yup
    .object()
    .shape({
      label: yup.string().required("Address is required to proceed"),
      value: yup.string().required("Address is required to proceed"),
    })
    .test("address.value", "Address is required to proceed", (value: any) => {
      if (value.value == "") {
        return false;
      } else return true;
    })
    .required("Address is required to proceed"),
});

function SectionOneBannerThemeThree() {
  const homedata: any = useSelector<any>((state) => state?.homeJsonList);
  const [postalCodeList, setPostalCodeList] = useState([]);
  const [postalCodeValue, setPostalCodeValue] = useState("");
  const [checkWithNewPin, setCheckWithNewPin] = useState(true);
  const [selectedAddress, setSelectedAddress] = useState<any>(null);
  const [coveredArea, setCoveredArea] = useState(false);
  const [areaData, setAreaData] = useState([]);
  const [selectedSuggestedAddress, setSelectedSuggestedAddress] =
    useState<any>(null);
  const [listOfSuggestedAddress, setListOfSuggestedAddress] = useState([]);
  const dispatch = useDispatch<any>();
  const state: any = useSelector((state) => state);
  const navigate = useNavigate();
  const href = window.location.href;
  const areaOptions: any = useSelector<any>(
    (state) => state?.addressByPincode?.data?.address_list,
  );
  useEffect(() => {}, [homedata]);

  useEffect(() => {
    if (state) {
      setPostalCodeList(state.postalCodeList);
    }
  }, [state]);

  const {
    handleSubmit: handlePinCodeSubmit,
    control: pinCodeFormControl,
    setError: setPinCodeFormError,
    setValue: setPinCodeFormValue,
    formState: { errors: pinCodeFormError },
  } = useForm({
    resolver: yupResolver(searchPinCodeFormSchema),
    mode: "onChange",
    defaultValues: {
      pinCode: "",
    },
  });

  const {
    handleSubmit: handleAddressSubmit,
    control: addressFormControl,
    setError: addressFormSetError,
    setValue: setAddressFormValue,
    getValues: getValuesAddressForm,
    reset: resetAddressForm,
    clearErrors,
    formState: { errors: addressFormError },
  } = useForm({
    resolver: yupResolver(addressFormSchema),
    mode: "onChange",
    defaultValues: {
      address: { value: "", label: "Select your address..." },
    },
  });
  const handleAddressChange = async (selected: any) => {
    setSelectedAddress(selected);
    setAddressFormValue("address", selected);
    if (getValuesAddressForm("address")?.value != "") {
      clearErrors();
    }
  };

  useEffect(() => {
    if (state) {
      setPostalCodeList(state.postalCodeList);
      // setValue("postalCode",state.postalCodeList[0]?.postcode)
    }
  }, [state]);

  useEffect(() => {
    if (checkWithNewPin == false) {
      setPinCodeFormValue("pinCode", "");
      setSelectedAddress(null);
      resetAddressForm();
    } else {
    }
  }, [checkWithNewPin]);

  useEffect(() => {
    let existingAddressSuggestion = JSON.parse(
      localStorage.getItem("addressSuggestions") || "[]",
    );
    setListOfSuggestedAddress(existingAddressSuggestion);
  }, []);

  const handleChange = (e: any) => {
    setCoveredArea(false);
    const { value } = e.target;
    const updateValue = value.replace(/\s/g, "");
    setPinCodeFormValue("pinCode", updateValue);
    if (value.length > 0) {
      dispatch(fetchPostalCodes(updateValue));
    }
    setPostalCodeValue(updateValue);
  };
  const onSearch = (searchTerm: any) => {
    setPinCodeFormValue("pinCode", searchTerm);
    setPostalCodeValue(searchTerm);
    setValue("postalCode", searchTerm.toUpperCase());
  };

  const submitAddressFromSuggestion = async (selected: any) => {
    setSelectedSuggestedAddress(selected);
    localStorage.setItem("postalCode", selected.postalCode);
    localStorage.setItem(
      "selectedAddressBeforeLogin",
      JSON.stringify(selected),
    );
    if (localStorage.getItem("token")) {
      // handle api
      const contact_name = JSON.parse(localStorage.getItem("userDetails")!).data
        ?.user_info.name;
      const mobile_number = JSON.parse(localStorage.getItem("userDetails")!)
        .data?.user_info.mobile;
      const address = selected?.value?.split(",");
      const payloadData = {
        address_type: "pickup",
        address_details: `{"contact_name":"${contact_name}","mobile_number":"${mobile_number}","line_1":"${address[0].trim()}","line_2":"${address[1].trim()}","line_3":"${address[2].trim()}","line_4":"${address[3].trim()}","locality":"${address[4].trim()}","city":"${address[5].trim()}","county":"${address[6].trim()}","label":"Home","pincode":"${JSON.parse(
          selected.postalCode,
        )}"}`,
      };
      const uniqueAddress = await dispatch(fetchSaveAddress(payloadData));
      if (
        uniqueAddress.status ||
        uniqueAddress.message == "Address already exists"
      ) {
        if (checkShopListFlow()) {
          localStorage.setItem("from", "home");
          navigate("/shopList");
        } else {
          let host = window.location.hostname;
          // If host contains fulham move to checkout directly
          if (host.includes("fulham") || host.includes("localhost")) {
            const results = await dispatch(
              fetchGetShopByPinCode(selected.postalCode),
            );

            if (!results) {
              setPinCodeFormError("pinCode", {
                type: "server",
                message: "Area not covered",
              });
              await fetchCoveredAreaCodes();
              setCoveredArea(true);
              return;
            }
            dispatch(setOrderType(1));
            setValue("orderType", 1);
            setValue("wbd", false);
            localStorage.removeItem("cartInformationData");
            dispatch(clearCartCount());
            dispatch(clearCart());
            dispatch(clearUserProductCategories());
            localStorage.removeItem("isloaded");
            // dispatch(clearSplitPrice());
            let userName = JSON.parse(localStorage.getItem("userDetails")!);
            localStorage.setItem("from", "home");
            userName == null ? navigate("/guestLogin") : navigate("/checkout");
            if (userName == null) {
              navigate("/login");
            } else {
              navigate("/checkOut");
            }
          } else {
            localStorage.setItem("from", "home");
            navigate("/productLists");
          }
        }
      } else {
        addressFormSetError("address", {
          type: "server",
          message: "Unable to set address try again later",
        });
      }
    } else {
      if (checkShopListFlow()) {
        localStorage.setItem("from", "home");
        navigate("/shopList");
      } else {
        let host = window.location.hostname;
        // If host contains fulham move to checkout directly
        if (host.includes("fulham") || host.includes("localhost")) {
          const results = await dispatch(
            fetchGetShopByPinCode(selected.postalCode),
          );

          if (!results) {
            setPinCodeFormError("pinCode", {
              type: "server",
              message: "Area not covered",
            });
            await fetchCoveredAreaCodes();
            setCoveredArea(true);
            return;
          }
          dispatch(setOrderType(1));
          setValue("orderType", 1);
          setValue("wbd", false);
          localStorage.removeItem("cartInformationData");
          dispatch(clearCartCount());
          dispatch(clearCart());
          dispatch(clearUserProductCategories());
          localStorage.removeItem("isloaded");
          // dispatch(clearSplitPrice());
          let userName = JSON.parse(localStorage.getItem("userDetails")!);
          localStorage.setItem("from", "home");
          userName == null ? navigate("/guestLogin") : navigate("/checkout");
          if (userName == null) {
            navigate("/login");
          } else {
            navigate("/checkOut");
          }
        } else {
          localStorage.setItem("from", "home");
          navigate("/productLists");
        }
      }
    }
  };

  const submitAddressChange = async () => {
    let postalCode: any = localStorage.getItem("postalCode");
    if (getValuesAddressForm("address")?.value == "") {
      addressFormSetError("address", {
        type: "server",
        message: "Address is required to proceed",
      });
    } else {
      clearErrors();
      localStorage.setItem(
        "selectedAddressBeforeLogin",
        JSON.stringify(selectedAddress),
      );
      let addressSuggestions: any = [{ ...selectedAddress }];
      addressSuggestions[0].postalCode = postalCode;
      if (localStorage.getItem("addressSuggestions")) {
        let existingAddressSuggestion = JSON.parse(
          localStorage.getItem("addressSuggestions") || "[]",
        );
        addressSuggestions = addressSuggestions.concat(
          existingAddressSuggestion,
        );
      }
      localStorage.setItem(
        "addressSuggestions",
        JSON.stringify(addressSuggestions),
      );
      setListOfSuggestedAddress(addressSuggestions);
      if (localStorage.getItem("token")) {
        // handle api
        const contact_name = JSON.parse(localStorage.getItem("userDetails")!)
          .data?.user_info.name;
        const mobile_number = JSON.parse(localStorage.getItem("userDetails")!)
          .data?.user_info.mobile;
        const address = selectedAddress?.value?.split(",");
        const payloadData = {
          address_type: "pickup",
          address_details: `{"contact_name":"${contact_name}","mobile_number":"${mobile_number}","line_1":"${address[0].trim()}","line_2":"${address[1].trim()}","line_3":"${address[2].trim()}","line_4":"${address[3].trim()}","locality":"${address[4].trim()}","city":"${address[5].trim()}","county":"${address[6].trim()}","label":"Home","pincode":"${JSON.parse(
            postalCode,
          )}"}`,
        };
        const uniqueAddress = await dispatch(fetchSaveAddress(payloadData));
        if (
          uniqueAddress.status ||
          uniqueAddress.message == "Address already exists"
        ) {
          if (checkShopListFlow()) {
            localStorage.setItem("from", "home");
            navigate("/shopList");
          } else {
            let host = window.location.hostname;
            // If host contains fulham move to checkout directly
            if (host.includes("fulham") || host.includes("localhost")) {
              const results = await dispatch(fetchGetShopByPinCode(postalCode));

              if (!results) {
                setPinCodeFormError("pinCode", {
                  type: "server",
                  message: "Area not covered",
                });
                await fetchCoveredAreaCodes();
                setCoveredArea(true);
                return;
              }
              dispatch(setOrderType(1));
              setValue("orderType", 1);
              setValue("wbd", false);
              localStorage.removeItem("cartInformationData");
              dispatch(clearCartCount());
              dispatch(clearCart());
              dispatch(clearUserProductCategories());
              localStorage.removeItem("isloaded");
              // dispatch(clearSplitPrice());
              let userName = JSON.parse(localStorage.getItem("userDetails")!);
              localStorage.setItem("from", "home");
              userName == null
                ? navigate("/guestLogin")
                : navigate("/checkout");
              if (userName == null) {
                navigate("/login");
              } else {
                navigate("/checkOut");
              }
            } else {
              localStorage.setItem("from", "home");
              navigate("/productLists");
            }
          }
        } else {
          addressFormSetError("address", {
            type: "server",
            message: "Unable to set address try again later",
          });
        }
      } else {
        if (checkShopListFlow()) {
          localStorage.setItem("from", "home");
          navigate("/shopList");
        } else {
          let host = window.location.hostname;
          // If host contains fulham move to checkout directly
          if (host.includes("fulham") || host.includes("localhost")) {
            const results = await dispatch(fetchGetShopByPinCode(postalCode));

            if (!results) {
              setPinCodeFormError("pinCode", {
                type: "server",
                message: "Area not covered",
              });
              await fetchCoveredAreaCodes();
              setCoveredArea(true);
              return;
            }
            dispatch(setOrderType(1));
            setValue("orderType", 1);
            setValue("wbd", false);
            localStorage.removeItem("cartInformationData");
            dispatch(clearCartCount());
            dispatch(clearCart());
            dispatch(clearUserProductCategories());
            localStorage.removeItem("isloaded");
            // dispatch(clearSplitPrice());
            let userName = JSON.parse(localStorage.getItem("userDetails")!);
            localStorage.setItem("from", "home");
            userName == null ? navigate("/guestLogin") : navigate("/checkout");
            if (userName == null) {
              navigate("/login");
            } else {
              navigate("/checkOut");
            }
          } else {
            localStorage.setItem("from", "home");
            navigate("/productLists");
          }
        }
      }
    }
  };

  const fetchCoveredAreaCodes = async () => {
    const base_url = process.env.REACT_APP_BACKEND_URL;
    try {
      const response = await axios({
        method: "get",
        url: `${base_url}/api/areas_covered_postcodes`,
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Methods": "GET, POST",
          "Access-Control-Allow-Origin": "*",
        },
      });
      if (response.data.Response.response_code == "1") {
        setAreaData(response.data.data);
      } else {
        return false;
      }
    } catch (error) {}
  };

  const submitPostalForm = async (data: any) => {
    localStorage.setItem("postalCode", JSON.stringify(data.pinCode));
    const shop = await dispatch(
      fetchGetShopByPinCode(JSON.stringify(data.pinCode)),
    );

    if (shop) {
      setCoveredArea(false);
      const result = await dispatch(fetchAddressByPincode());
      if (result.status == 200 && result.data.data?.address_list.length > 0) {
        setCheckWithNewPin(false);
        setCoveredArea(false);
      } else {
        if (href.includes("wblaundry") /* || href.includes('localhost') */) {
          navigate("/areaNotCovered");
        } else {
          setPinCodeFormError("pinCode", {
            type: "server",
            message: "Area not covered",
          });
          await fetchCoveredAreaCodes();
          setCoveredArea(true);
        }
      }
    } else {
      if (href.includes("wblaundry") /* || href.includes("localhost") */) {
        navigate("/areaNotCovered");
      } else {
        setPinCodeFormError("pinCode", {
          type: "server",
          message: "Area not covered",
        });
        setPinCodeFormValue("pinCode", "");
        setPostalCodeValue("");
        await fetchCoveredAreaCodes();
        setCoveredArea(true);
      }
    }
  };

  const bgMedia = "/assets/home/bg-1.png";

  const filteredPostalCodes = postalCodeList
    .filter((item: any) => {
      const searchTerm = postalCodeValue.toLowerCase();
      const mainValue = item.postcode.toLowerCase();
      return (
        searchTerm &&
        mainValue.startsWith(searchTerm) &&
        mainValue !== searchTerm
      );
    })
    .slice(0, 10);

  return (
    <section className="t3hero-wrap">
      <div className="t3hero-shell">
        <div className="t3hero-content">
          {homedata?.theme_3?.home?.section_1?.sub_heading_top && (
            <span className="t3hero-tag">
              {homedata?.theme_3?.home?.section_1?.sub_heading_top}
            </span>
          )}
          <h1 className="t3hero-title">
            {homedata?.theme_3?.home?.section_1?.title}
          </h1>
          <p id="bookNow" className="t3hero-sub">
            {homedata?.theme_3?.home?.section_1?.paragraph}
          </p>
          <div className="t3hero-rating">
            <span className="t3hero-stars">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </span>
            <span>Trusted by 10,000+ happy customers</span>
          </div>

          <div className="t3hero-card">
            <form onSubmit={handlePinCodeSubmit(submitPostalForm)}>
              <div
                className={`t3hero-form ${
                  checkWithNewPin == false ? "d-none" : ""
                }`}
              >
                <div
                  className={`t3hero-input-wrap ${
                    pinCodeFormError.pinCode ? "invalid" : ""
                  }`}
                >
                  <Controller
                    name="pinCode"
                    control={pinCodeFormControl}
                    render={({ field }) => (
                      <input
                        type="text"
                        id="postcode-input"
                        {...field}
                        placeholder={
                          homedata?.theme_3?.home?.section_1?.btn_group?.btn1
                            ?.placeholder
                        }
                        className="t3hero-input"
                        onChange={handleChange}
                        autoComplete="off"
                      />
                    )}
                  />
                  <button
                    className="t3hero-btn"
                    id="book_now_btn"
                    type="submit"
                    style={{
                      background: `#${homedata?.theme_3?.home?.section_1?.btn_group?.btn1?.bg_color}`,
                      color: `#${homedata?.theme_3?.home?.section_1?.btn_group?.btn1?.color}`,
                    }}
                  >
                    {homedata?.theme_3?.home?.section_1?.btn_group?.btn1?.text}
                  </button>
                </div>
                <small className="t3hero-error">
                  {pinCodeFormError.pinCode?.message}
                </small>

                {filteredPostalCodes.length > 0 && (
                  <div className="t3hero-dropdown">
                    {filteredPostalCodes.map((item: any) => (
                      <div
                        onClick={() => onSearch(item.postcode)}
                        className="t3hero-dropdown-row"
                        key={item.postcode}
                      >
                        <i className="fas fa-map-marker-alt"></i>
                        {item.postcode}
                      </div>
                    ))}
                  </div>
                )}

                {coveredArea && (
                  <div className="t3hero-dropdown">
                    <div className="t3hero-dropdown-heading">
                      Postcode areas we currently covered
                    </div>
                    {areaData.map((item: any) => (
                      <div
                        onClick={() => {
                          onSearch(item);
                          setCoveredArea(false);
                        }}
                        className="t3hero-dropdown-row"
                        key={item}
                      >
                        <i className="fas fa-map-marker-alt"></i>
                        {item}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </form>

            <form>
              <div
                className={`t3hero-form ${
                  checkWithNewPin == true ? "d-none" : ""
                }`}
              >
                <div className="t3hero-select-row">
                  <Controller
                    name="address"
                    control={addressFormControl}
                    render={({ field }) => (
                      <Select
                        placeholder="Select your address"
                        {...field}
                        value={selectedAddress}
                        className={`${
                          addressFormError.address ? "invalid" : ""
                        }`}
                        onChange={handleAddressChange}
                        onFocus={() => {
                          if (getValuesAddressForm("address").value == "") {
                            addressFormSetError("address", {
                              type: "server",
                              message: "Address is required to proceed",
                            });
                          } else {
                            clearErrors();
                          }
                        }}
                        options={areaOptions}
                      />
                    )}
                  />
                  <input
                    type="button"
                    value="Continue"
                    className="t3hero-btn"
                    style={{ background: "#00adb5", color: "#fff" }}
                    onClick={submitAddressChange}
                  />
                </div>
                <small className="t3hero-error">
                  {addressFormError.address?.message}
                </small>

                <div className="t3hero-or">OR</div>
                <a
                  className="t3hero-link"
                  onClick={() => {
                    setCheckWithNewPin(true);
                  }}
                >
                  Check with another Postcode
                </a>
              </div>
            </form>

            {listOfSuggestedAddress.length > 0 && (
              <>
                <span className="t3hero-recent-label">
                  Or, select a recent address
                </span>
                <Swiper
                  spaceBetween={12}
                  navigation={true}
                  modules={[Navigation]}
                  pagination={{
                    el: ".swiper-pagination",
                    clickable: true,
                  }}
                  breakpoints={{
                    640: { slidesPerView: 1 },
                    768: { slidesPerView: 1 },
                    1024: { slidesPerView: 2 },
                  }}
                  className="slider-adrs"
                >
                  {listOfSuggestedAddress.map((address: any, index: any) => (
                    <SwiperSlide key={index}>
                      <div
                        className="t3hero-chip"
                        onClick={() => submitAddressFromSuggestion(address)}
                      >
                        <div className="t3hero-chip-label">
                          <span>{address.label}</span>
                          <span className="t3hero-chip-pcode">
                            {address.postalCode}
                          </span>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </>
            )}

            <SectionOfferSingle />
          </div>
        </div>

        {bgMedia && (
          <div className="t3hero-side">
            <div className="t3hero-side-portrait">
              <img src={bgMedia} alt="" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default SectionOneBannerThemeThree;
